/* Storefront SDKs. Shopify's native integration owns Meta commerce; the custom pixel pairs quiz/partner events. */
(() => {
  const config = window.__MOSES_STOREFRONT_ANALYTICS__;
  if (!config || window.__mosesStorefrontAnalyticsStarted ||
      window.__MOSES_ANALYTICS__?.environment !== 'production' ||
      !['moses.com', 'www.moses.com'].includes(location.hostname)) return;
  window.__mosesStorefrontAnalyticsStarted = true;
  const ID_KEY = 'moses_posthog_distinct_id';
  const BRIDGE_KEY = 'moses_posthog_session';
  const STATUS_KEY = 'moses_posthog_status';
  const GA_BRIDGE_KEY = 'moses_ga4_session';
  const GA_ATTR_KEY = 'moses_ga4_attribution';
  const pageStartedAt = Date.now();
  const utmNames = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content'];
  let allowed = false, phLoading = false, ph = null, gaLoaded = false, syncTimer;
  const read = (storage, key) => { try { return storage.getItem(key); } catch { return null; } };
  const write = (storage, key, value) => { try { storage.setItem(key, value); } catch {} };
  const parse = value => { try { return JSON.parse(value || '{}') || {}; } catch { return {}; } };
  function recorderStatus(state) {
    write(sessionStorage, STATUS_KEY, JSON.stringify({state, updated_at: Date.now(), page_started_at: pageStartedAt}));
  }
  function safeUrl(value) {
    if (!value) return '';
    try {
      const url = new URL(value, location.origin);
      let path = url.pathname;
      if (/\/(checkouts|checkout)(\/|$)/.test(path)) path = '/checkout';
      if (/\/orders\//.test(path)) path = '/orders';
      return url.origin + path;
    } catch { return ''; }
  }
  function loadScript(src, onload) {
    const script = document.createElement('script');
    script.src = src; script.async = true; script.crossOrigin = 'anonymous';
    script.onload = onload;
    script.onerror = () => {
      phLoading = false;
      if (src.includes('array.js')) recorderStatus('sdk_load_failed');
    };
    document.head.appendChild(script);
  }
  function syncIdentity() {
    if (!allowed || !ph) return;
    const id = read(localStorage, ID_KEY);
    if (id && id !== ph.get_distinct_id()) {
      // A shared browser changing buyers must start a new identity and recording.
      if (String(ph.get_distinct_id()).includes('@')) ph.reset();
      ph.identify(id);
    }
    const sessionId = ph.get_session_id();
    const previous = parse(read(sessionStorage, BRIDGE_KEY));
    // Preserve campaign entry across internal pages, but reset it when the SDK starts a new session.
    const params = new URL(location.href).searchParams;
    const entryUtms = previous.version === 2 && previous.session_id === sessionId
      ? previous.entry_utms : Object.fromEntries(utmNames.filter(key => params.has(key))
        .map(key => [key, params.get(key).slice(0, 200)]));
    const bridge = {
      version: 2, session_id: sessionId, distinct_id: ph.get_distinct_id(), updated_at: Date.now(),
      page_url: safeUrl(location.href), page_started_at: pageStartedAt, entry_utms: entryUtms,
    };
    write(sessionStorage, BRIDGE_KEY, JSON.stringify(bridge));
    return bridge;
  }
  function startPostHog() {
    if (!config.posthogEnabled || !config.posthogToken) { recorderStatus('sdk_disabled'); return; }
    if (ph || phLoading) return;
    phLoading = true;
    recorderStatus('sdk_loading');
    loadScript('https://us-assets.i.posthog.com/static/array.js', () => {
      phLoading = false;
      if (!allowed) return;
      const attribution = parse(read(localStorage, 'moses_attribution'));
      const id = read(localStorage, ID_KEY) || attribution.anon_id || crypto.randomUUID();
      write(localStorage, ID_KEY, id);
      window.posthog.init(config.posthogToken, {
        api_host: 'https://us.i.posthog.com', ui_host: 'https://us.posthog.com',
        defaults: '2026-05-30', bootstrap: {distinctID: id, isIdentifiedID: id.includes('@')},
        person_profiles: 'identified_only',
        autocapture: false, capture_pageview: false, capture_pageleave: false,
        capture_dead_clicks: false, rageclick: false, capture_exceptions: false,
        capture_heatmaps: false, capture_performance: false, disable_surveys: true,
        disable_session_recording: false, enable_recording_console_log: false,
        session_recording: {
          maskAllInputs: true,
          // Keep the journey visible; only documents/signatures are fully excluded.
          blockSelector: '.onboarding-document, .onboarding-pad, [data-ph-block], iframe',
          maskTextSelector: '.quiz-error, .onboarding-account, .onboarding-signing, .onboarding-suggestions, .pac-container, [data-ph-mask], .shopify-challenge__container',
          recordCanvas: false, recordHeaders: false, recordBody: false,
          streamNetworkBody: false, captureJsonLd: false,
          maskCapturedNetworkRequestFn: request => ({...request, name: safeUrl(request.name)}),
        },
        before_send: event => {
          if (!allowed) return null;
          const props = event.properties || {};
          for (const key of Object.keys(props)) {
            if (/url|referrer/i.test(key) && typeof props[key] === 'string') props[key] = safeUrl(props[key]);
          }
          return event;
        },
        loaded: instance => {
          ph = instance;
          if (!allowed) { ph.opt_out_capturing(); return; }
          // Reconcile a persisted SDK opt-out with Shopify's current analytics consent.
          // Startup must restore capture just like a later consent-granted event does.
          ph.opt_in_capturing({captureEventName: false});
          ph.startSessionRecording();
          ph.register({...window.__MOSES_ANALYTICS__, $current_url: safeUrl(location.href), $referrer: safeUrl(document.referrer)});
          const bridge = syncIdentity();
          recorderStatus('sdk_ready');
          // Publish readiness through Shopify as well as storage. The pixel may have
          // started before the SDK download or may be unable to read the storage bridge.
          try {
            window.Shopify?.analytics?.publish('moses_replay_ready', bridge);
          } catch { /* the storage bridge remains available */ }
          ph.onSessionId(syncIdentity);
          // One SDK event per page gives the replay a searchable page marker without duplicating pixel pageviews.
          ph.capture('storefront_replay_page', {path: location.pathname});
          syncTimer = setInterval(syncIdentity, 2000);
        },
      });
    });
  }
  function googleAdsAllowed() {
    const privacy = window.Shopify?.customerPrivacy;
    return allowed && privacy?.marketingAllowed?.() === true && privacy?.saleOfDataAllowed?.() === true;
  }
  // Separate from PostHog URL masking: only allowlisted, consented Google attribution survives.
  function googleAttribution() {
    const cached = parse(read(sessionStorage, GA_ATTR_KEY));
    const age = Date.now() - Number(cached.updated_at);
    const params = new URL(location.href).searchParams;
    const fields = {utm_source:'campaign_source', utm_medium:'campaign_medium', utm_campaign:'campaign_name', utm_term:'campaign_term', utm_content:'campaign_content'};
    const clicks = ['gclid', 'gbraid', 'wbraid'];
    const newEntry = [...Object.keys(fields), ...clicks].some(key => params.has(key));
    const fresh = age >= 0 && age < 30 * 60 * 1000;
    const campaign = {}, clickIds = {};
    for (const [key, field] of Object.entries(fields)) {
      const value = newEntry ? params.get(key) : fresh ? cached.campaign?.[field] : null;
      if (typeof value === 'string' && /^[a-zA-Z0-9 _./:~-]{1,200}$/.test(value)) campaign[field] = value;
    }
    if (googleAdsAllowed()) for (const key of clicks) {
      const value = newEntry ? params.get(key) : fresh ? cached.click_ids?.[key] : null;
      if (typeof value === 'string' && /^[a-zA-Z0-9._~-]{1,512}$/.test(value)) clickIds[key] = value;
    }
    write(sessionStorage, GA_ATTR_KEY, JSON.stringify({campaign, click_ids: clickIds, updated_at: Date.now()}));
    const url = new URL(safeUrl(location.href));
    for (const [key, value] of Object.entries(clickIds)) url.searchParams.set(key, value);
    return {campaign, page_location: url.href};
  }
  let googleConsentInitialized = false;
  function updateGoogleConsent() {
    if (!config.ga4Enabled || !/^G-[A-Z0-9]+$/.test(config.ga4Id)) return;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    if (!googleConsentInitialized) {
      window.gtag('consent', 'default', {analytics_storage:'denied', ad_storage:'denied', ad_user_data:'denied', ad_personalization:'denied'});
      googleConsentInitialized = true;
    }
    const ads = googleAdsAllowed() ? 'granted' : 'denied';
    window['ga-disable-' + config.ga4Id] = !allowed;
    window.gtag('consent', 'update', {analytics_storage:allowed?'granted':'denied', ad_storage:ads, ad_user_data:ads, ad_personalization:ads});
    if (!googleAdsAllowed()) {
      const cached = parse(read(sessionStorage, GA_ATTR_KEY));
      if (allowed) write(sessionStorage, GA_ATTR_KEY, JSON.stringify({...cached, click_ids:{}}));
      else { try { sessionStorage.removeItem(GA_ATTR_KEY); } catch {} }
    }
    if (gaLoaded) {
      const attribution = allowed ? googleAttribution() : {campaign:{}, page_location:safeUrl(location.href)};
      window.gtag('config', config.ga4Id, {
        send_page_view:false, page_location:attribution.page_location, allow_google_signals:false,
        allow_ad_personalization_signals:googleAdsAllowed(), ...attribution.campaign,
      });
    }
  }
  function refreshGoogleIdentity() {
    if (!allowed || !gaLoaded) return Promise.resolve();
    // Checkout waits briefly for current IDs; a blocked tag must never block buying.
    write(sessionStorage, GA_BRIDGE_KEY, '');
    return new Promise(resolve => {
      const timeout = setTimeout(resolve, 500);
      window.gtag('get', config.ga4Id, 'client_id', clientId => {
        window.gtag('get', config.ga4Id, 'session_id', sessionId => {
          clearTimeout(timeout);
          if (allowed && /^\d{1,20}\.\d{1,20}$/.test(String(clientId)) && /^\d{1,20}$/.test(String(sessionId))) {
            write(sessionStorage, GA_BRIDGE_KEY, JSON.stringify({
              client_id: clientId, session_id: sessionId, updated_at: Date.now(),
              identity_source: 'gtag', measurement_id: config.ga4Id,
            }));
          }
          resolve();
        });
      });
    });
  }
  window.MosesRefreshGoogleIdentity = refreshGoogleIdentity;
  function startGoogle() {
    if (!config.ga4Enabled || !/^G-[A-Z0-9]+$/.test(config.ga4Id) || gaLoaded) return;
    gaLoaded = true;
    window.gtag('js', new Date());
    const attribution = googleAttribution();
    window.gtag('config', config.ga4Id, {
      page_location: attribution.page_location, page_referrer: safeUrl(document.referrer),
      allow_google_signals: false, allow_ad_personalization_signals: googleAdsAllowed(),
      ...attribution.campaign,
    });
    refreshGoogleIdentity();
    loadScript('https://www.googletagmanager.com/gtag/js?id=' + config.ga4Id, () => {});
  }
  function updateConsent(event) {
    const stored = parse(read(localStorage, 'moses-cookie-consent'));
    const explicit = event?.detail?.analyticsAllowed;
    allowed = typeof explicit === 'boolean' ? explicit :
      stored.analytics === 'no' ? false : window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
    updateGoogleConsent();
    if (allowed) {
      if (ph) { ph.opt_in_capturing({captureEventName: false}); ph.startSessionRecording(); syncIdentity(); }
      else startPostHog();
      startGoogle();
    } else {
      recorderStatus('consent_denied');
      if (ph) { ph.stopSessionRecording(); ph.opt_out_capturing(); }
      try { sessionStorage.removeItem(BRIDGE_KEY); } catch {}
      try { sessionStorage.removeItem(GA_BRIDGE_KEY); } catch {}
      window['ga-disable-' + config.ga4Id] = true;
      // updateGoogleConsent already revoked every Google consent signal.
    }
  }
  document.addEventListener('visitorConsentCollected', updateConsent);
  window.addEventListener('storage', event => {
    if (event.key === 'moses-cookie-consent') updateConsent();
    else if (event.key === ID_KEY) syncIdentity();
  });
  window.addEventListener('pagehide', () => clearInterval(syncTimer));
  window.addEventListener('pageshow', event => {
    if (event.persisted) { updateConsent(); clearInterval(syncTimer); syncTimer = setInterval(syncIdentity, 2000); }
  });
  if (window.Shopify?.customerPrivacy) updateConsent();
  else window.Shopify?.loadFeatures?.([{name:'consent-tracking-api', version:'0.1'}], error => { if (!error) updateConsent(); });
})();
